const DEPTH_AXIS_FIELDS = new Set(['md', 'tvd', 'tvdss', 'ns', 'we', 'closure', 'vsec', 'ahd', 'centrToCentr']);
const ANGLE_AXIS_FIELDS = new Set(['inc', 'azi']);
const SEVERITY_AXIS_FIELDS = new Set(['dls']);

export type TrajectoryAxisUnits = {
  depth: string | null;
  severity: string | null;
};

export function formatAxisLabel(name: string, unit: string | null | undefined): string {
  if (!unit) {
    return name;
  }

  return `${name}, ${unit}`;
}

export function unitForAxisField(field: string, units: TrajectoryAxisUnits): string | null {
  if (DEPTH_AXIS_FIELDS.has(field)) {
    return units.depth;
  }

  if (ANGLE_AXIS_FIELDS.has(field)) {
    return '°';
  }

  if (SEVERITY_AXIS_FIELDS.has(field)) {
    return units.severity;
  }

  return null;
}
